import { Loc, t } from "@/locales";
import { FieldLabel } from "./FieldLabel";

type Props = {
  // Pre-formatted by the feature layer, so this primitive stays free of
  // configurator-specific money helpers.
  amount: string;
  currency: string;
};

export function TotalPrice(props: Props) {
  return (
    <div className="total-price">
      <FieldLabel>{t(Loc.totalLabel)}</FieldLabel>
      <div className="total-price__figures">
        <div className="total-price__value">
          <span className="total-price__amount">{props.amount}</span>
          <span className="total-price__currency">{props.currency}</span>
        </div>
        <div className="total-price__note">{t(Loc.totalNote)}</div>
      </div>
    </div>
  );
}
